import React from 'react';

const StudentPromotion = () => {
  return <div>Student Promotion is Available in React</div>;
};

export default StudentPromotion;
